import { constructSizes } from "@lululemon/ui-library";
import { MAX_GRID_WIDTH } from "./breakpoints";

export const WWMT_IMG_WIDTHS = {
  desktop: MAX_GRID_WIDTH,
  tablet: 992,
  mobile: 98
};

export const pdpCarouselWWMTImageWidths = constructSizes([
  { breakpoint: `${WWMT_IMG_WIDTHS.desktop}`, slotSize: "900px" },
  { breakpoint: `${WWMT_IMG_WIDTHS.tablet}px`, slotSize: "50vw" },
  { slotSize: `${WWMT_IMG_WIDTHS.mobile}vw` }
]);
